import { connect } from 'react-redux';
import Admin from '../../components/admin';

import {
    fetchCurrentlyAssignedTo,
    selectAll,
    counter,
    fetchCurrentlyAssignedToEvents,
    fetchReassignTo,
    reassignSubmitThunk,
    removeSubmissionBanner
} from '../../actions';

import {
    getUserInfo,
    getUserInfoLoading,
    getAuthentication,
    getCurrentlyAssignedTo,
    getAssignedData,
    getCounter,
    getSuccessSubmission,
    getAssignedDataLoading,
    getReassignTo,
    getReassignSubmitLoading
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: getUserInfo(state),
    userLoading: getUserInfoLoading(state),
    authentication: getAuthentication(state),
    currentlyAssignedTo: getCurrentlyAssignedTo(state),
    currentlyAssignedToValue: state.adminForm.currentlyAssignedTo,
    reassignToValue: state.adminForm.reassignTo,
    assignedData: getAssignedData(state),
    count: getCounter(state),
    successSubmission: getSuccessSubmission(state),
    getAssignedDataLoading: getAssignedDataLoading(state),
    getReassignTo: getReassignTo(state),
    getReassignSubmitLoading: getReassignSubmitLoading(state)
});

const mapDispatchToProps = dispatch => ({
    fetchCurrentlyAssignedTo: () => dispatch(fetchCurrentlyAssignedTo()),
    selectAll: type => dispatch(selectAll(type)),
    counter: () => dispatch(counter()),
    fetchCurrentlyAssignedToEvents: id =>
        dispatch(fetchCurrentlyAssignedToEvents(id)),
    fetchReassignTo: data => dispatch(fetchReassignTo(data)),
    reassignSubmitThunk: () => dispatch(reassignSubmitThunk()),
    removeSubmissionBanner: () => dispatch(removeSubmissionBanner())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin);



// WEBPACK FOOTER //
// ./src/containers/admin/index.js